module.exports = __webpack_public_path__ + "static/image/history/pc/202312@x3.ver2_0_2.jpg?39c20519";